export const convertFormatStrToFormats = ({ formatStr }: { formatStr: string }) => {
  const allFormats = formatStr
    .split(',')
    .map((f) => f.trim())
    .filter(Boolean);

  const firstFormat = allFormats[0] || '';
  const spaceIndex = firstFormat.indexOf(' ');
  let countryCode = (spaceIndex > 0 ? firstFormat.slice(0, spaceIndex) : '').trim();
  countryCode = countryCode.startsWith('+') ? countryCode : `+${countryCode}`;

  // Extract patterns without country code
  const formatsWithoutCountryCode = allFormats
    .map((f) => {
      if (f.startsWith('+')) {
        return f.slice(f.indexOf(' ') + 1);
      }
      return f;
    })
    .sort((a, b) => a.length - b.length);

  const formatsWithCountryCode = formatsWithoutCountryCode.map((pattern) => `${countryCode} ${pattern}`);

  return { countryCode, formatsWithCountryCode, formatsWithoutCountryCode };
};

export const getNumberWithoutCountryCode = (value: string, countryCode: string) => {
  const valueWithoutCountryCode = value.replace(new RegExp(`^\\${countryCode}\\s*`), '');

  return valueWithoutCountryCode;
};

export const getDigitCount = (value: string) => {
  return value.replace(/\D/g, '').length;
};

export const getFormatDigitCount = (format: string) => {
  return format.replace(/[^#]/g, '').length;
};

export const getFormatsWithoutCountryCode = (formats: string[]) => {
  return formats.map((format) => {
    if (format.startsWith('+')) {
      return format.slice(format.indexOf(' ') + 1);
    }
    return format;
  });
};

export const findMatchingFormat = (rawValue: string, countryCode: string, formats: string[]) => {
  if (!rawValue) {
    // TODO: Remove hardcoded default format
    return formats[0] ?? '(###) ###-####';
  }
  // Clean the input value
  const valueWithoutCode = getNumberWithoutCountryCode(rawValue, countryCode);
  const digitsCount = getDigitCount(valueWithoutCode);
  const formatsSortedByMinLength = formats.sort((a, b) => getFormatDigitCount(a) - getFormatDigitCount(b));

  const match = formatsSortedByMinLength.find((format) => getFormatDigitCount(format) >= digitsCount);

  return (match || formats[0]) ?? '(###) ###-####';
};

// Helper to get max allowed digits from formats
export const getMaxAllowedDigits = (formats: string[]) => {
  const cleanFormats = formats.map((format) => format.slice(format.indexOf(' ') + 1));
  return Math.max(...cleanFormats.map(getFormatDigitCount));
};

export const stripCountryCodeFromPhoneNumber = (value: string) => {
  const valueWithoutCountryCode = value.replace(/^\+\d+\s/, '');
  const valueWithDigitsOnly = valueWithoutCountryCode.replace(/\D/g, '');
  return valueWithDigitsOnly;
};
